// Centralized utilities for Cliniko patient context params

const SS_PATIENT_ID = 'cliniko_patient_id';
const SS_SEEN_AT = 'cliniko_params_seen_at';

export function getClinikoPatientIdFromSearch(search = '') {
    try {
        const sp = new URLSearchParams(search || '');
        return sp.get('patient_id') || sp.get('patientId') || null;
    } catch {
        return null;
    }
}

export function persistClinikoPatientId(patientId) {
    if (!patientId) return;
    try {
        sessionStorage.setItem(SS_PATIENT_ID, patientId);
    } catch {
        /* noop */
    }
}

export function clearClinikoPatientId() {
    try {
        sessionStorage.removeItem(SS_PATIENT_ID);
        sessionStorage.removeItem(SS_SEEN_AT);
    } catch {
        /* noop */
    }
}

export function getClinikoPatientIdFromStorage() {
    try {
        return sessionStorage.getItem(SS_PATIENT_ID);
    } catch {
        return null;
    }
}

export function markClinikoParamsSeen() {
    try {
        sessionStorage.setItem(SS_SEEN_AT, String(Date.now()));
    } catch {
        /* noop */
    }
}

export function getClinikoParamsSeenAt() {
    try {
        const raw = sessionStorage.getItem(SS_SEEN_AT);
        return raw ? Number(raw) : 0;
    } catch {
        return 0;
    }
}
